<template>
  <div style="position: relative;">
    <!-- 主页面按钮 -->
    <div v-if="currentView === 'main'">
      <div class="button-container">
        <el-button class="rounded-button"
                 @click="handleCreate">制作</el-button>
        <el-button class="rounded-button"
                 @click="switchView('gallery')">图库</el-button>
        <el-button class="rounded-button"
                 @click="switchView('dashboard')">课程中心</el-button>
      </div>
    </div>

    <!-- 二级页面 -->
    <Photo v-if="currentView === 'gallery'"></Photo>
    <Dashboard v-if="currentView === 'dashboard'"></Dashboard>

    <!-- 返回按钮 -->
    <el-button 
      v-if="currentView !== 'main'" 
      @click="switchView('main')" 
      class="back" 
      type="primary">
      返回
    </el-button>
  </div>
</template>

<script>
import Photo from '../views/Photo.vue';
import Dashboard from './Dashboard.vue';

export default {
  data() {
    return {
      currentView: 'main', // 可选值: 'main', 'gallery', 'dashboard'
      loadingInstance: null,
    };
  },

  components: {
    Photo,
    Dashboard,
  },

  methods: {
    // 切换视图
    switchView(view) {
      this.currentView = view;
    },

    // 启动软件
    handleCreate() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: '正在启动 GoodLaser 软件，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      try {
        const newWindow = window.open('GoodLaser://launch?foreground=true', '_blank');
        if (newWindow) {
          newWindow.focus();
        }
      } catch (error) {
        console.error('启动失败:', error);
        this.$message.error('启动失败，请手动打开 GoodLaser');
      } finally {
        setTimeout(() => {
          if (this.loadingInstance) {
            this.loadingInstance.close();
          }
        }, 3000);
      }
    },
  },
};
</script>

<style scoped>
.button-container {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
}

.rounded-button {
  width: 240px;
  height: 240px;
  border-radius: 20px;
  color: #fff;
  background-color: cornflowerblue;
  transition: all 0.3s ease; /* 添加过渡效果 */
}

.rounded-button:hover {
  transform: scale(1.05); /* 悬停时放大效果 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* 悬停时添加阴影 */
}

.back {
  position: absolute;
  left: 5px;
  top: 10px;
  width: 40px;
  font-size: 12px;
  height: 15px;
  padding: 0;
}

/* 添加页面切换动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
